<template>
  <div class="page final result">
    <main>
      <div class="citybg"></div>
      <div class="ornamentline"></div>
      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">
            Oui,
            <br />je veux des enfants.
          </h2>
          <p class="bodyslide--final">
            Tu envisages donc de concevoir un premier enfant à {{ age }} ans et tu aimerais avoir {{ kinderen }} enfants. Vous commencez heureusement à
            temps.
            <br />
            <br />Chez les femmes, la fertilité commence à diminuer légèrement à partir de 25 ans et plus radicalement après 30 ans.
          </p>
        </div>
        <div class="babylyingcontainer">
          <img src="./../assets/img/babylying.svg" class="babylying" />
        </div>
      </header>
      <section class="infosection" id="facts">
        <div class="leftblok">
          <header>
            <h3 class="sectiontitle">Le savais-tu ?</h3>
            <p class="sectionintro">
              Certains couples qui veulent concevoir un premier enfant à cet âge-là et fonder une famille nombreuse doivent revoir à la baisse leurs plans et faire l’impasse sur le nombre d’enfants désirés.
            </p>
          </header>
          <div class="articleblocks">
            <article>
              <p class="articlebody">
                <br />Si tu ne veux pas courir ce risque, mieux vaut commencer à 25 ans qu’à 29.
              </p>
            </article>
          </div>
          <div class="articleblocks">
            <article>
              <h4 class="articletitle">Âge de la partenaire</h4>
              <p class="articlebody">
                Si ta partenaire a moins de 30 ans, tu as <strong>85 % de chances</strong> de grossesse dans l’année. Tu dois tenir compte du fait que vous aurez peut-être déjà tous les deux dépassé 30 ans lorsque tu voudras concevoir ton deuxième ou troisième enfant. À l’âge de 30 ans, les femmes ont <strong>75 % de chances</strong> de grossesse dans l’année. Ce chiffre passe à <strong>66 %</strong> si elles souhaitent concevoir un enfant à 35 ans.

                <br />
                <br />Ta partenaire est plus âgée que toi ou tu as envie d’en savoir plus sur l'effet de l'âge sur la fertilité ? Alors, clique 
                <router-link to="/extrainfo#houdbaarheidsdatum">ici</router-link
                >&nbsp;.
              </p>
            </article>
            <article>
              <h4 class="articletitle">Mode de vie</h4>
              <p class="articlebody">
                Bien entendu, l’âge n’est pas le seul déterminant de la fertilité d’un couple. Même si tu es encore jeune, tant chez les hommes que chez les femmes, un certain nombre de maladies peuvent retarder une grossesse. Un mode de vie sain est important pour les deux partenaires afin d’augmenter les chances de grossesse.
                <br />
                <br />Tu trouveras de plus amples informations sur l’impact du mode de vie sur la fertilité ici:
                <br/><br/>
                <ul class="opsomming">
                    <!--li>
                      <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/sante/visite-préconceptionnelle/">Visite préconceptionnelle.</a>
                    </li-->
                    <li>
                      <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/consultation-peps/des-questions-sur-la-conception/">Des questions sur la conception.</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.one.be/public/videodetail/youtube/air-de-familles-grossesse-la-visite-préconceptionnelle/">Vidéos informatives - Air de famille -: la visite préconceptionnelle.</a>
                    </li>
                    </ul>
              </p>
              <p>
                <levensweg-button
                  class="nextButtonresults"
                  label="Complément d’information"
                  color="blue right"
                  link="extrainfo"
                />
              </p>
            </article>
          </div>
        </div>
        <div class="rightblok">
          <aside class="parentsaside">
            <img src="./../assets/img/parents.svg" class="parents" />
          </aside>
          <div class="rightblock__line" />
        </div>
      </section>

      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton,
  },
  computed: {
    age() {
      let compAge =
        18 +
        this.$store.state.verderstuderen +
        this.$store.state.activiteitentijd;
      return compAge;
    },
    kinderen() {
      return this.$store.state.aantalkindereren;
    },
  },
};
</script>

<style>
.result .nextButtonresults a:link,
.result .nextButtonresults a:visited,
.result .nextButtonresults a:link:active,
.result .nextButtonresults a:visited:active {
  color: white;
  margin-left: 0;
}

.nextButtonresults {
  margin-top: 3rem;
  margin-bottom: 3rem;
  text-align: center;
}
.result a:link,
.result a:visited,
.result a:link:active,
.result a:visited:active {
  color: var(--blue);
}
.articlebody strong {
  font-weight: bold;
}
.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}

.planningtop {
  margin-top: 2.2rem;
}

.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}
.rightblock__line__flipped {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_ivf.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 259px;
  height: 402px;
  z-index: -1;
  margin-top: -7rem;
}
.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}
.rightblok.ivfblok:after {
  margin-top: 2rem;
}

.parents {
  width: 232px;
  height: 319px;
}
.ivf {
  width: 342px;
  height: 324px;
}

.babylyingcontainer {
  /*margin-left: calc(-26.13% * 2);*/
  margin-top: 4rem;
  margin-bottom: 8rem;
  z-index: -2;
}
.babylying {
  height: auto;
  width: 100%;
}
/*
.babylying {
  width: auto;
  height: 291px;
  object-fit: cover;
}*/
.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}
.infosection {
  display: flex;
  flex-direction: column;
}
.articleblocks {
  display: flex;
  flex-direction: column;
}
.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  margin-right: 4.4rem;
}
.articlebody.noheading {
  margin-top: 3rem;
}

.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
  }
  .babylying {
    width: 80%;
    max-width: 457px;
    height: 80%;
    max-height: 374px;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }

  .sectionintro {
    width: 75%;
  }
  .rightblok:after {
    display: none;
  }
  .infosection:after {
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width: 80%;
    height: 80%;
    margin-top: 3rem;
    right: 0;
  }
  .infosection.plan:after {
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width: 80%;
    height: 80%;
    margin-top: 3rem;
    left: 0;
    transform: rotate(180deg);
  }
  .rightblock__line__flipped {
    align-self: flex-start;
  }
  .parentsaside {
    align-self: flex-start;
  }
  .titleslide--final {
    width: 100%;
    max-width: 400px;
  }
}

@media only screen and (min-width: 992px) {
  #facts .articlebody {
    width: 75%;
  }

  .header--final {
    flex-direction: row-reverse;
  }
  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection {
    flex-direction: row;
    align-items: flex-start;
  }
  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }

  .articleblocks article {
    flex: 50%;
  }
  .planningtop .articlebody {
    width: 50%;
  }

  .sectionintro {
    width: 70%;
  }
  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}
@media only screen and (min-width: 1200px) {
  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
  }
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
